function titleCase(text) {
  if (!text) {
    return '';
  }

  //Convert string to title case
  var formattedText = text.replace(/[A-Z]/g, char => ' ' + char).trim();

  return formattedText[0].toUpperCase() + formattedText.substring(1);
}

angular.module('clientDashboardApp').filter('titleCase', () => titleCase);

export {titleCase}
